import { DealsWidgetConfig } from "./config";
import iconCrossSvg from "./assets/icon__cross.svg";
import iconDealSvg from "./assets/icon__deal.svg";

// Builds trigger, dismisser, and backdrop - panel is a separate sub-component
// <div class="deals_widget">
//   <div class="deals_widget__backdrop"></div>
//   <div class="deals_widget__dismisser">
//     <button class="deals_widget__dismisser_button">
//       <svg class="deals_widget__dismisser_icon deals_widget__dismisser_icon--cross">...</svg>
//       <svg class="deals_widget__dismisser_icon deals_widget__dismisser_icon--deal">...</svg>
//     </button>
//   </div>
//   <div class="deals_widget__trigger">
//     <div class="deals_widget__trigger_promo">...</div>
//     <div class="deals_widget__trigger_title"></div>
//   </div>
// </div>

export default class DealsWidgetBuilder {
  constructor(baseElement) {
    this.element = this.buildElement(baseElement);
  }

  getElement() {
    return this.element;
  }

  buildElement(baseElement) {
    let element = baseElement;
    element.classList.add(DealsWidgetConfig.baseHtmlClass);

    // Add breakpointer for responsive layout
    // S breakpoint uses range [0, 350] so --S is applied when narrow (not when wide)
    element.classList.add("breakpointer");
    element.dataset.breakpointer = JSON.stringify({
      class: "deals_widget",
      breakpoints: { S: [0, 350] }
    });

    // DOM order: Backdrop → Dismisser → Trigger (Panel inserted before trigger by sub-component)
    element.appendChild(this.buildBackdropElement());
    element.appendChild(this.buildDismisserElement());
    element.appendChild(this.buildTriggerElement());

    return element;
  }

  buildDismisserElement() {
    let element = document.createElement("div");
    element.classList.add("deals_widget__dismisser");

    let button = document.createElement("button");
    button.classList.add("deals_widget__dismisser_button");
    button.setAttribute("aria-label", "Dismiss deals widget");

    // Cross icon - shown in normal state
    let crossIcon = document.createElement("span");
    crossIcon.classList.add("deals_widget__dismisser_icon", "deals_widget__dismisser_icon--cross");
    crossIcon.innerHTML = iconCrossSvg;
    button.appendChild(crossIcon);

    // Deal icon - shown in dismissed state (tab)
    let dealIcon = document.createElement("span");
    dealIcon.classList.add("deals_widget__dismisser_icon", "deals_widget__dismisser_icon--deal");
    dealIcon.innerHTML = iconDealSvg;
    button.appendChild(dealIcon);

    element.appendChild(button);
    return element;
  }

  buildTriggerElement() {
    let element = document.createElement("div");
    element.classList.add("deals_widget__trigger");

    // Promo container - promocode component added dynamically after config fetch
    let promoElement = document.createElement("div");
    promoElement.classList.add("deals_widget__trigger_promo");
    element.appendChild(promoElement);

    // Title container - populated after deals fetch with header text
    let titleElement = document.createElement("div");
    titleElement.classList.add("deals_widget__trigger_title");
    element.appendChild(titleElement);

    return element;
  }

  buildBackdropElement() {
    let element = document.createElement("div");
    element.classList.add("deals_widget__backdrop");
    return element;
  }
}
